import { DatastoreInterface } from '@freelancer/datastore/core';
import { Domain } from './domains.model';
import { DomainsCollection } from './domains.types';

export async function createDomain(datastore: DatastoreInterface) {
  const object = generateDomainObject();
  await datastore.createRawDocument<DomainsCollection>('domains', object);
  return object;
}

function generateDomainObject(): Domain {
  return {
    id: 62,
    domainName: 'localhost',
    region: 'North America',
    flagBig: 'us-big.png',
    flagSmall: 'us.png',
    info: 'Go to localhost',
    infoSelected: 'Stay in localhost',
    name: 'Local Development Server',
    pattern: '/localhost$/',
    sequence: 0,
    shortName: 'usa',
    url: 'https://www.syd1.fln-dev.net/dashboard?w=t&webapp_local',
  };
}
